const injectGA4 = () => {
// Initialize Google Analytics
  (function (i, s, o, g, r, a, m) {
    i.GoogleAnalyticsObject = r
    i[r] = i[r] || function (...args) {
      (i[r].q = i[r].q || []).push(args)
    }
    i[r].l = 1 * new Date()
    a = s.createElement(o)
    m = s.getElementsByTagName(o)[0]
    a.async = 1
    a.src = g
    m.parentNode.insertBefore(a, m)
  }(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga'))

  const { ga } = window
  ga('create', 'UA-141216178-1', 'auto')
  ga('require', 'ec') // Enhanced eCommerce plugin
  ga('set', 'currencyCode', 'USD') // Set currency to USD.
}

export const loadGA4 = () => {
  if (window.location.href.includes('ahaslides.eu')) {
    return
  }

  // Check if GA is already loaded
  if (window.ga) {
    return
  }
  injectGA4()

  console.log('GA4 initialized successfully')
}
